export const qfsGroups = {
  QFSOP: {
    id: 'QFSOP',
    order: 0,
    questions: {
      QFS01: {
        id: 'QFS01',
        order: 0,
      },
      QFS02: {
        id: 'QFS02',
        order: 1,
      },
    },
  },
  QFSSO: {
    id: 'QFSSO',
    order: 1,
    questions: {
      QFS05: {
        id: 'QFS05',
        order: 0,
      },
      QFS14: {
        id: 'QFS14',
        order: 1,
      },
      QFS08: {
        id: 'QFS08',
        order: 2,
      },
      QFS07: {
        id: 'QFS07',
        order: 3,
      },
    },
  },
  QFSBI: {
    id: 'QFSBI',
    order: 2,
    questions: {
      QFS09: {
        id: 'QFS09',
        order: 0,
      },
    },
  },
  QFSEN: {
    id: 'QFSEN',
    order: 3,
    questions: {
      QFS11: {
        id: 'QFS11',
        order: 0,
      },
    },
  },
}

export type QFSTotalKey = 'QFSTT'
export type QFSGroupKey = keyof typeof qfsGroups
export type QFSQuestionKey =
  | keyof (typeof qfsGroups)['QFSOP']['questions']
  | keyof (typeof qfsGroups)['QFSSO']['questions']
  | keyof (typeof qfsGroups)['QFSBI']['questions']
  | keyof (typeof qfsGroups)['QFSEN']['questions']
export type QFSKey = QFSTotalKey | QFSGroupKey | QFSQuestionKey

export const isQFSGroupKey = (id: string): id is QFSGroupKey =>
  Object.keys(qfsGroups).includes(id)
export const isQFSQuestionKey = (id: string): id is QFSQuestionKey =>
  Object.keys(qfsGroups.QFSOP.questions).includes(id) ||
  Object.keys(qfsGroups.QFSSO.questions).includes(id) ||
  Object.keys(qfsGroups.QFSBI.questions).includes(id) ||
  Object.keys(qfsGroups.QFSEN.questions).includes(id)

export const isQFSKey = (id: string): id is QFSKey =>
  id === 'QFSTT' || isQFSGroupKey(id) || isQFSQuestionKey(id)
